import SendAmount, { amountTypeToLabel } from './send_amount'
import { reduxForm } from 'redux-form'
import { getFullName, formatMoney } from 'griffin'
import { AMOUNT_TYPES } from 'shared/shared_consts'
import formUtils from 'lib/form_utils'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/send_glimpse/send_amount')

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  const { location: { pathname = '' } = {} } = props
  return {
    shouldAutoFocus: props.router.params.action !== 'POP',
    displayName: getFullName({
      givenName: campaign.owner.first_name,
      surname: campaign.owner.last_name,
    }),
    title: campaign.title,
    campaignType: campaign.campaign_type,
    currency: campaign.currency,
    amountType: campaign.amount_type || AMOUNT_TYPES.any,
    amount: campaign.amount,
    maxAmount: campaign.max_amount,
    initialValues: {
      amount: campaign.amount_type !== AMOUNT_TYPES.any ? campaign.amount : 0,
      anonymous: false,
    },
    isGuest: pathname.includes('guest'),
    countryCode: state.country.country_code,
    locale: state.country.locale,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

function amountValidator() {
  return (values, props) => {
    const amount = parseFloat(values.amount)

    if (props.amountType === AMOUNT_TYPES.at_least) {
      const formattedAmount = formatMoney(
        props.currency,
        props.initialValues.amount,
        { removeTrailingZeros: false }
      )
      const errorLabel = i18n(amountTypeToLabel(props.amountType), {
        amount: formattedAmount,
      })

      if (!values.amount) {
        return { amount: errorLabel }
      }

      if (amount < props.amount) {
        return { amount: errorLabel }
      }
    } else if (props.amountType === AMOUNT_TYPES.any) {
      const errorLabel = i18n('amount_required')
      if (!values.amount) {
        return { amount: errorLabel }
      }
      if (amount === 0) {
        return { amount: errorLabel }
      }
    }

    if (props.maxAmount) {
      if (amount > props.maxAmount) {
        const formattedAmount = formatMoney(props.currency, props.maxAmount, {
          removeTrailingZeros: false,
        })
        const errorLabel = i18n('max_amount', { amount: formattedAmount })
        return { amount: errorLabel }
      }
    }

    return {}
  }
}

export default reduxForm(
  {
    form: 'send',
    fields: ['amount', 'anonymous'],
    destroyOnUnmount: false,
    touchOnChange: false,
    touchOnBlur: true,
    validate: amountValidator(),
  },
  mapStateToProps,
  mapDispatchToProps
)(formUtils(SendAmount))
